"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.af3956Schema = void 0;
const yup = __importStar(require("yup"));
exports.af3956Schema = yup.object().shape({
    id: yup.string().notRequired(),
    asOf: yup.string().nullable(),
    nameAndGrade: yup.string().nullable(),
    ssn: yup.string().nullable(),
    organizationAndLocation: yup.string().nullable(),
    art: yup.boolean(),
    memberDataRows: yup.array().nullable(),
    atpPerformanceNumberAftp: yup.string().nullable(),
    atpPerformanceNumberAgtp: yup.string().nullable(),
    atpPerformanceForPayAftp: yup.string().nullable(),
    atpPerformanceNorPayAgtp: yup.string().nullable(),
    atpThisPeriodNumberAftp: yup.string().nullable(),
    atpThisPeriodNumberAgtp: yup.string().nullable(),
    atpThisPeriodForPayAftp: yup.string().nullable(),
    atpThisPeriodForPayAgtp: yup.string().nullable(),
    totalAtpPerformanceNumberAftp: yup.string().nullable(),
    totalAtpPerformanceNumberAgtp: yup.string().nullable(),
    totalAtpPerformanceForPayAftp: yup.string().nullable(),
    totalAtpPerformanceForPayAgtp: yup.string().nullable(),
    date: yup.string().nullable(),
    typeOrStampedNameGradeTitle: yup.string().nullable(),
    signature: yup.string().nullable(),
    eventId: yup.string().nullable(),
    isLocked: yup.boolean().notRequired(),
});
